export { default } from "@features/investments/screens/etf-detail-screen";
